import React, { useEffect } from 'react'
import { useDispatch, useSelector } from '../../store'
import { isEmpty } from 'lodash'
import { DetailsView } from '../CloudAccountWrapper/DetailsView'
import { LayoutWrapper } from '@labrav/common'
import { CombinedForm } from '../../components/CombinedForm'
import { getCurrentCombinedFormData } from '../../modules/combinedForm/action'
import type { CombinedFormState } from '../../modules/combinedForm/types'
import { CircularProgress } from '@mui/material'
import { useStyles } from './ResaleCppoFormDetails.styles'

interface ResaleCppoFormDetailsProps {
  cloud: string
  labraFormId: string
}

const ResaleCppoFormDetails: React.FC<ResaleCppoFormDetailsProps> = ({
  cloud,
  labraFormId,
}) => {
  const dispatch = useDispatch()
  const { classes } = useStyles()
  const queryParams = new URLSearchParams(location.search)
  const labraProductID = queryParams.get('labra_product_id') as string

  // Get data from Redux
  const combinedFormData = useSelector(
    (state: { combinedFormInCreation: CombinedFormState }) =>
      state.combinedFormInCreation || ({} as CombinedFormState)
  )

  // Fetch data when params change
  useEffect(() => {
    const initialize = async () => {
      if (!isEmpty(labraFormId) && cloud === 'aws') {
        try {
          await dispatch(
            getCurrentCombinedFormData(
              labraFormId as string,
              labraProductID as string
            )
          )
        } catch (error) {
          console.error('Error fetching combined form data:', error)
        }
      }
    }

    initialize()
  }, [labraFormId, cloud])
  return (
    <>
      {combinedFormData.status === 'DRAFT' ? (
        <LayoutWrapper
          title="Edit Private Offer"
          component={CombinedForm}
          isExternal
          paddingZero
        />
      ) : combinedFormData.status === 'APPROVED' ||
        combinedFormData.status === 'REJECTED' ? (
        <LayoutWrapper
          title="Offer Details"
          component={DetailsView}
          isExternal
          paddingZero
        />
      ) : (
        <div className={classes.loadingContainer}>
          <CircularProgress size={30} />
        </div>
      )}
    </>
  )
}

export default ResaleCppoFormDetails
